
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Paragraph, List, Anatomy, Link } from '@ecl/website-components';

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Paragraph size="lead" mdxType="Paragraph">
  On this page you will find information related to the European Commission
  branded <strong>Harmonised group 2 websites</strong> that host specific
  content that answers a particular communication purpose, in particular:
    </Paragraph>
    <List size="lead" mdxType="List">
  <li>
    <strong>Event website</strong> - Purpose of advertising a specific or
    repeatedly occurring activity that is open to the public, organised and/or
    hosted by the European Commission. Event websites are only allowed for large
    and complex events that cannot be accommodated by the events content type
  </li>
  <li>
    <strong>Campaign website</strong> - Providing online communication endeavour
    dedicated to promoting a single or several thematically linked activities,
    initiatives, services or products
  </li>
  <li>
    <strong>Blogs</strong> - Regularly updated websites dedicated to publishing
    general features and news items about specific European Commission
    activities
  </li>
    </List>
    <h2>{`Anatomy`}</h2>
    <Anatomy image="https://inno-ecl.s3.amazonaws.com/media/images/EC/HarmonisedTemplate/harmonised-2-template.png" alt="Anatomy of the harmonised template - group 2" legend={{
      items: [{
        color: '#404040',
        label: 'Mandatory'
      }, {
        color: '#004494',
        label: 'Optional'
      }]
    }} mdxType="Anatomy" />
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Elements`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Mandatory`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><Link to="https://webgate.ec.europa.eu/fpfis/wikis/display/webtools/Global+banner" standalone mdxType="Link">{`Global banner`}</Link></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The Global banner is the official EU stamp that gives a visual indicator and easy access to EU institutions and bodies sites, guaranteeing the user visits an official EU website`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><Link to="/ec/harmonised-templates/site-header/group2/" standalone mdxType="Link">{`Harmonised site header`}</Link></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><p>{`The Harmonised site header is present on every page. It communicates the European Commission brand and provides basic structure and guidance. The site header is composed of several mandatory and optional elements such as:`}</p><ul><li>{`European Commission logo`}</li><li>{`Language select`}</li><li>{`Europa search form`}</li></ul></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><Link to="/ec/harmonised-templates/page-header/group2/" standalone mdxType="Link">{`Harmonised page header`}</Link></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`No`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><p>{`The Harmonised page header gives context and information to the user on what the page is about. It is present on every page, just below the site header, except for the homepage. The page header is composed of mandatory and optional elements such as:`}</p><ul><li>{`Breadcrumb`}</li><li>{`Meta`}</li><li>{`Page title`}</li><li>{`Introduction`}</li></ul></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><Link to="/ec/harmonised-templates/footer/group2/" standalone mdxType="Link">{`Harmonised footer`}</Link></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The Harmonised footer is present on every page. It provides supplementary information such as copyright, legal, privacy, social media, contact information and links to other important sections within the European Commission ecosystem.`}</td>
        </tr>
      </tbody>
    </table>
    <p><strong parentName="p">{`NOTE`}</strong>{`: On the Page body section, ECL components are optional.`}</p>
    <h2>{`Structural anatomy`}</h2>
    <p>{`When designing the page, make sure to follow appropriate category guidelines available below in terms of structure and layout`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Elements`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Mandatory`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><Link to="/ec/utilities/grid/" standalone mdxType="Link">{`Grid`}</Link></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Recommended`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Enhance visual consistency`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><Link to="/ec/guidelines/colours/" standalone mdxType="Link">{`Colours`}</Link></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Contextual `}{`*`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Use only European Commission colour specifications available in the ECL`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><Link to="/ec/guidelines/typography/" standalone mdxType="Link">{`Typography`}</Link></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Contextual `}{`*`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Apply the typographic guidelines available in the ECL`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><Link to="/ec/guidelines/spacing/" standalone mdxType="Link">{`Spacing`}</Link></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Contextual `}{`*`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Apply spacing rules explained in the ECL`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><Link to="/ec/guidelines/iconography/" standalone mdxType="Link">{`Icons`}</Link></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Contextual `}{`*`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Where icons feature, use commonly-used icons from the ECL`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><Link to="/ec/guidelines/images/" standalone mdxType="Link">{`Images`}</Link></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Contextual `}{`*`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`See image guidelines in ECL`}</td>
        </tr>
      </tbody>
    </table>
    <Paragraph size="s" mdxType="Paragraph">
  * <strong>Contextual</strong> – elements that may or may not feature on a
  page, depending on the communication and/or functional needs – for example,
  Login. Where the element features, use the ECL component.
    </Paragraph>
    <h2>{`Do's`}</h2>
    <ul>
      <li parentName="ul">{`ensure the pages contain all the elements in the anatomy table above`}</li>
    </ul>
    <h2>{`Don'ts`}</h2>
    <ul>
      <li parentName="ul">{`do not replace pages only on existing websites as this will create visual inconsistencies, this must be done at a site level`}</li>
    </ul>
    <h2>{`When to use`}</h2>
    <ul>
      <li parentName="ul">{`the Harmonised template must be used for all new development and can also be introduced on existing pages to replace a previous template, but this should be done on a site basis, not page by page`}</li>
    </ul>
    <h2>{`When not to use`}</h2>
    <ul>
      <li parentName="ul">{`do not follow these guidelines when you are updating sites that fall under the `}<Link to="/ec/core-template/" mdxType="Link">{`Core`}</Link>{` or `}<Link to="/ec/standardised-template/" mdxType="Link">{`Standardised`}</Link>{` category`}</li>
      <li parentName="ul">{`do not follow these guidelines when you are updating sites that fall under web information systems, network or internal policy websites - use `}<Link to="/ec/harmonised-templates/group1/" mdxType="Link">{`Harmonised Group 1`}</Link>{` instead`}</li>
    </ul>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;